var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterLimitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_200_373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 101.5,
    r: 85.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 101.5,
    r: 85.25,
    stroke: "url(#paint0_linear_200_373)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.838 44.4003C159.44 52.3569 166.903 62.5855 171.549 74.1576C176.195 85.7298 177.878 98.2791 176.445 110.666C175.011 123.054 170.507 134.887 163.341 145.092C156.174 155.298 146.573 163.552 135.408 169.105C124.243 174.659 111.867 177.336 99.4052 176.894C86.9429 176.452 74.7883 172.905 64.0446 166.575C53.3009 160.244 44.3081 151.331 37.8827 140.644C31.4572 129.956 27.8024 117.834 27.25 105.376L38.2935 104.886C38.7643 115.505 41.8796 125.838 47.3565 134.948C52.8334 144.057 60.4986 151.655 69.6563 157.051C78.8141 162.447 89.1744 165.47 99.7969 165.847C110.419 166.224 120.968 163.941 130.485 159.208C140.002 154.474 148.186 147.438 154.294 138.74C160.403 130.041 164.242 119.955 165.464 109.396C166.686 98.837 165.251 88.1403 161.291 78.2765C157.33 68.4127 150.969 59.6941 142.785 52.912L149.838 44.4003Z",
    fill: "#1286DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1824 103.001C27.0444 92.0309 29.3186 81.1642 33.8442 71.1699C38.3699 61.1755 45.0364 52.2978 53.3721 45.1645L60.5593 53.5634C53.4541 59.6436 47.7718 67.2108 43.9142 75.7298C40.0567 84.2487 38.1182 93.5112 38.2359 102.862L27.1824 103.001Z",
    fill: "#E1DE06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9373 43.0659C62.5871 37.867 70.0681 33.8298 78.0639 31.125L81.6061 41.5964C74.7906 43.9019 68.414 47.3431 62.7459 51.7746L55.9373 43.0659Z",
    fill: "#3EDB51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1045 30.4672C91.3035 27.0329 103.152 26.2738 114.698 28.2508L112.832 39.1465C102.991 37.4613 92.8912 38.1084 83.3455 41.0357L80.1045 30.4672Z",
    fill: "#33E4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.054 28.6933C128.531 31.0389 139.297 36.0443 148.487 43.307L141.633 51.98C133.8 45.7895 124.623 41.5231 114.84 39.5237L117.054 28.6933Z",
    fill: "#00C7BD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddii_200_373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 101.5,
    r: 53.6471,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 101.5,
    r: 53.3971,
    stroke: "url(#paint1_linear_200_373)",
    strokeWidth: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.862 55.0161C102.304 54.9212 102.764 54.9508 103.19 55.1011C103.617 55.2513 103.993 55.5166 104.277 55.8677C104.946 56.6942 113.063 66.7866 121.016 78.9399C124.992 85.017 128.935 91.6195 131.885 97.8433C134.827 104.051 136.812 109.945 136.812 114.583C136.812 133.516 121.364 148.916 102.375 148.916C83.39 148.916 67.9415 133.516 67.9414 114.583C67.9414 111.001 69.0906 106.792 70.9336 102.318C72.7796 97.8366 75.3377 93.0515 78.1904 88.3052C83.8955 78.8132 90.8059 69.4343 95.624 62.894C96.6697 61.4748 97.6843 60.0967 98.4883 58.979C99.2745 57.8859 99.8322 57.0761 100.033 56.7134C100.153 56.3045 100.378 55.9333 100.687 55.6382C101.013 55.3262 101.42 55.111 101.862 55.0161Z",
    fill: "white",
    stroke: "#006AB8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 54,
    width: 69,
    height: 94
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.13 55.4858C102.392 55.4296 102.665 55.4467 102.917 55.5356C103.17 55.6246 103.392 55.7824 103.56 55.9897C104.22 56.8052 112.321 66.8783 120.255 79.0034C124.223 85.067 128.142 91.6337 131.068 97.8062C134.001 103.995 135.905 109.725 135.905 114.134C135.905 132.53 120.892 147.499 102.434 147.5C83.9799 147.5 68.9664 132.53 68.9663 114.134C68.9663 110.739 70.0615 106.668 71.8862 102.238C73.708 97.8154 76.2413 93.0724 79.0825 88.3452C84.7654 78.8902 91.6546 69.5384 96.481 62.9868C97.5265 61.5678 98.5462 60.1835 99.355 59.0591C100.153 57.9501 100.773 57.0558 100.995 56.6382L101.022 56.5864L101.037 56.5298C101.104 56.2723 101.242 56.0384 101.435 55.854C101.628 55.6697 101.869 55.542 102.13 55.4858Z",
    fill: "white",
    stroke: "#006AB8"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_373)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_200_373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 55,
    width: 69,
    height: 94
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.164 55.5322C102.426 55.476 102.699 55.4931 102.951 55.582C103.204 55.671 103.426 55.8288 103.594 56.0361C104.254 56.8515 112.355 66.9247 120.289 79.0498C124.257 85.1134 128.176 91.6801 131.102 97.8525C134.035 104.041 135.938 109.771 135.938 114.181C135.938 132.576 120.926 147.546 102.468 147.546C84.0136 147.546 69.0001 132.577 69 114.181C69 110.785 70.0951 106.714 71.9199 102.284C73.7417 97.8618 76.2749 93.1188 79.1162 88.3916C84.7991 78.9366 91.6883 69.5847 96.5146 63.0332C97.5602 61.6141 98.5799 60.2299 99.3887 59.1055C100.186 57.9965 100.807 57.1022 101.028 56.6846L101.056 56.6328L101.07 56.5762C101.138 56.3187 101.276 56.0848 101.469 55.9004C101.662 55.7161 101.902 55.5884 102.164 55.5322Z",
    fill: "white",
    stroke: "#006AB8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_200_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1552 103.976C63.8046 105.957 52.5 126.57 52.5 126.57L57.3758 153H151.5L149.804 109.305C149.804 109.305 141.631 101.246 135.389 102.057C128.882 102.904 128.039 104.642 121.821 106.747C112.132 110.026 108.438 100.801 98.7141 103.976C94.9999 105.188 92.9192 105.633 89.1745 106.747C81.7592 108.953 78.6246 101.963 71.1552 103.976Z",
    fill: "url(#paint2_linear_200_373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1552 105.976C67.8046 107.957 56.5 128.57 56.5 128.57L61.3758 155H155.5L153.804 111.305C153.804 111.305 145.631 103.246 139.389 104.057C132.882 104.904 132.039 106.642 125.821 108.747C116.132 112.026 112.438 102.801 102.714 105.976C98.9999 107.188 96.9192 107.633 93.1745 108.747C85.7592 110.953 82.6246 103.963 75.1552 105.976Z",
    fill: "url(#paint3_linear_200_373)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_200_373",
    x: 0,
    y: 0,
    width: 199,
    height: 199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.739604 0 0 0 0 0.830609 0 0 0 0 0.934615 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_200_373",
    result: "effect2_dropShadow_200_373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_200_373",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.463055 0 0 0 0 0.587988 0 0 0 0 0.730769 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_200_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_200_373",
    result: "effect4_innerShadow_200_373"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddii_200_373",
    x: 37.8531,
    y: 37.8531,
    width: 127.294,
    height: 127.294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.660255 0 0 0 0 0.78111 0 0 0 0 0.919231 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_200_373",
    result: "effect2_dropShadow_200_373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_200_373",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.604904 0 0 0 0 0.742615 0 0 0 0 0.9 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_200_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_200_373",
    result: "effect4_innerShadow_200_373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_200_373",
    x1: 16,
    y1: 9.10484,
    x2: 69.0927,
    y2: 74.6089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_200_373",
    x1: 47.8532,
    y1: 43.5267,
    x2: 81.1662,
    y2: 84.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_200_373",
    x1: 102,
    y1: 102,
    x2: 102,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_200_373",
    x1: 106,
    y1: 104,
    x2: 106,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLimitIcon);
export default __webpack_public_path__ + "static/media/Water Limit Icon.4cd42bb540fe37168ab128792db96e5c.svg";
export { ForwardRef as ReactComponent };